<template>
  <div id="debug">
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
    <div id="space-data-csv-upload">
      <h4>空間データCSVアップロード</h4>
      <div>
        <ul class="select_list">
          <li
            class="radio"
            v-for="(objectType, idx) in uploadFileObjectTypeList"
            :key="objectType.code"
          >
            <input type="radio" :id="'debug_upload_' + idx" :value="objectType" v-model="uploadFileObjectType">
            <label :for="'debug_upload_' + idx">{{ objectType.label }}</label>
          </li>
        </ul>
        <input ref="fileInput" type="file" multiple="multiple" accept=".csv" @change="onUploadFileChange" />
        <button @click="uploadSpaceDataCsv" type="button" class="main_btn">アップロード</button>
        <div class="info_message" v-if="message">{{ message }}</div>
        <div class="error_message" v-if="fieldErrorMessages.required">{{ fieldErrorMessages.required }}</div>
        <div class="error_message" v-if="fieldErrorMessages.valid">{{ fieldErrorMessages.valid }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import {API_URL} from '../../../constants/App'
import {OBJECT_TYPE} from '../../../constants/Type'
import * as Api from '../../../utils/Api'
import * as App from '../../../utils/App'
import LoadingModal from '../../../components/common/LoadingModal'

export default {
  name: 'Debug',
  components: {
    'dd-loading-modal': LoadingModal
  },
  props: {
  },
  data () {
    return {
      // *****************************************************************
      // 空間データCSVアップロード
      // *****************************************************************
      uploadFiles: [],
      /** アップロードファイルタイプ */
      uploadFileObjectType: OBJECT_TYPE.OTANI,
      uploadFileObjectTypeList: [ OBJECT_TYPE.OTANI ],
      message: '',
      errorMessage: { text: '' },
      fieldErrorMessages: {
        required: '',
        valid: ''
      }
    }
  },
  computed: {
    isUseOrder: function () {
      let user = App.getUserInfo()
      return user && user.menuServiceCode.debugOrder
    }
  },
  methods: {
    // *****************************************************************
    // 空間データCSVアップロード
    // *****************************************************************
    onUploadFileChange: function (event) {
      event.preventDefault()
      this.clearMessages()
      this.uploadFiles = event.target.files
    },
    uploadSpaceDataCsv: function (event) {
      event.preventDefault()
      this.clearMessages()

      // 送信データ
      let payload = new FormData()
      for (let i = 0; i < this.uploadFiles.length; i++) {
        payload.append('files', new Blob([this.uploadFiles[i]], {type: 'application/csv'}), this.uploadFiles[i].name)
      }
      payload.append('objectType', this.uploadFileObjectType.code)
      axios.post(API_URL.UPLOAD + '/csv/space-data/customize', payload
      ).then(response => {
        if (response.data.errorMessage) {
          let modalData = {
            title: '空間編集エラー',
            messages: response.data.errorMessage.split(/\r?\n/g),
            messageType: 'error',
            textAlign: 'left',
            onOk: this.getEditingFileData
          }
          App.showModal(modalData)
        } else {
          this.message = response.data.infoMessage
          // this.clearFiles()
          this.$emit('fileUploadCallback')
        }
      }).catch(error => {
        Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
      })
    },
    clearFiles: function () {
      this.$refs.fileInput.value = ''
      this.uploadFiles = []
    },
    clearMessages: function () {
      this.message = ''
      this.errorMessage = { text: '' }
      this.fieldErrorMessages = {
        required: '',
        valid: ''
      }
    }
  }
}
</script>
<style src="../../../css/planning/side_tab_nav.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
h4+div {
  margin-bottom: 10px;
}
input[type=file] {
  cursor: pointer;
}
button {
  width: 110px;
  margin-bottom: 5px;
}
#space-data-csv-upload {
  input {
    max-width: calc(100% - 26px);
    margin-bottom: 10px;
  }
  .info_message, .error_message {
    margin-top: 10px;
    margin-left: 10px;
  }
}
.select_list {
  display: flex;
  flex-wrap: wrap;
  line-height: 35px;
  padding: 0 10px;
  margin-bottom: 10px;
  background: #e9e9e9;
  .radio {
    label:focus, label:hover {
      color: #68C2C3;
    }
    label:focus:before, label:hover:before, label:active:before, input:checked + label:before {
      border-color: #68c2c3;
      background: #ffffff;
    }
    input[type=radio] {
      display: none;
      padding: .375rem .75rem;
      line-height: 1.5;
    }
    label {
      display: inline-block;
      font-weight: bold;
      position: relative;
      overflow: hidden;
      padding-left: 27px;
      cursor: pointer;
      -webkit-transition: all 0.15s ease;
      transition: all 0.15s ease;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    label:before {
      position: absolute;
      top: 10px;
      left: 10px;
      width: 8px;
      height: 8px;
      content: '';
      border: 0.2em solid #cccccc;
      background: #fff;
    }
    input:checked + label:before {
      border-color: #68c2c3;
      background: #68c2c3;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/planning/tab/Otani.vue